let filesaver = {
    saveAs: () => null,
};

if (typeof navigator !== 'undefined') {
    filesaver = require('file-saver');
}

export default filesaver;
